import { MenuItem } from './menu.model';
import { environment } from 'src/environments/environment';

export const MENU: MenuItem[] = [
  { label: 'Ingresar', icon: 'lock', link: '/login' },
];

//PROJECT_MANAGER
//ACTIVITY_REPORTE

const projectArea = ["project director", "project manager"]
const projectDirectorOnly = ["project director"]
const financialDirectorOnly = ["financial director"]
const employeeArea = ["employee", "area manager", "technical leader"]
const financialArea = ["financial director", "financial analyst"]
const commercialArea = ["commercial director", "sales executive"]
const generalArea = ["general director"]
const resourceManagerArea = ["resource manager"]
const capacityAccessArea = projectArea.concat(resourceManagerArea).concat(generalArea).concat(employeeArea).concat(financialDirectorOnly).concat(["admin"])
export const ALL_AREAS = projectArea.concat(employeeArea).concat(financialArea).concat(commercialArea).concat(generalArea)


export const MENU_AUTH: MenuItem[] = [
  {
    label: 'Menu',
    isTitle: true
  },
  { label: 'Mi Espacio', icon: 'home', link: '/home', role: projectArea.concat(employeeArea)},
  { label: 'Tratos', icon: 'briefcase', link: '/offerts' , role: projectArea.concat(financialArea).concat(commercialArea),routes: [ "ofertDetails", "ofertForm"]},
  { label: 'Proyectos', icon: 'layers', link: '/proyects', role:projectArea.concat(financialArea) ,routes: [ "proyectDetails","proyectForm"]},
  { label: 'Reportes', icon: 'bar-chart-2', link: '/reportes', role: projectArea.concat(financialArea).concat(commercialArea).concat(generalArea)},
  { label: 'Mis Tableros', icon: 'columns', link: '/kanban', role: ALL_AREAS, routes: ['kanban'], dynamic: true, subItems: [] },
  { label: 'Financiero', icon: 'trending-up', link: '/financial', role: ["financial director", "project manager", "project director", "general director"], routes: ['financial'] },
  ...(environment.features?.capacityPlanning ? [
    { label: 'Capacidad', icon: 'pie-chart', link: '/capacity-planning', role: capacityAccessArea, routes: ['capacity-planning'] }
  ] : []),
  {
    label: 'Configuración',
    isTitle: true
  },
  { label: 'Pais', icon: 'flag', link: '/pais', role: projectDirectorOnly.concat(financialArea).concat(commercialArea) },
  { label: 'Empleados', icon: 'user-check', link: '/employees', role: projectDirectorOnly.concat(financialArea) },
  { label: 'Clientes', icon: 'briefcase', link: '/customers', role: projectDirectorOnly.concat(financialArea).concat(commercialArea) },
  { label: 'Interesados', icon: 'user-plus', link: '/interested', role: projectDirectorOnly.concat(commercialArea) },
  { label: 'Roles', icon: 'shield', link: '/roles', role: projectDirectorOnly.concat(financialArea) },
  { label: 'Categorías', icon: 'tag', link: '/categorias', role: projectDirectorOnly },
  { label: 'Equipos', icon: 'users', link: '/equipos', role: projectDirectorOnly },
  { label: 'Salarios', icon: 'dollar-sign', link: '/empleados-salarios', role: financialDirectorOnly },

];